import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Button from '@material-ui/core/Button'
import { Link } from 'react-router-dom'
import { makePath } from '../../../lib';
import Fade from '@material-ui/core/Fade'
import { Typography } from '@material-ui/core'
import FavoriteIcon from '@material-ui/icons/FavoriteBorder'
import { useState } from 'react'
import { useEffect } from 'react'
import { useContext } from 'react'
import { SettingsContext } from '../../Settings'
import CustomAvatar from '../../CustomAvatar/CustomAvatar'

const styles = theme => ({
  cardActions: {
    justifyContent: 'center',
    paddingBottom: theme.spacing.unit * 3,
  },
  avatar: {
    margin: theme.spacing.unit,
    textDecoration: 'none'
  },
  donors: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center'
  },
  numberOfDonor: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing.unit * 2,
  },
  icon: {
    marginRight: theme.spacing.unit,
  },
  description: {
    lineHeight: 1.75,
    marginBottom: theme.spacing.unit * 2,
  }
})

const DonorListCard = (props) => {
  const { classes } = props

  const [isInitialized, setIsInitialized] = useState(false)
  const [donors, setDonors] = useState(undefined)
  const [total, setTotal] = useState(0)

  const settingsContext = useContext(SettingsContext)
  const { language } = settingsContext

  useEffect(() => {
    if (!isInitialized) {
      props.fetch()
      .then(response => {
        if (!response.result) {
          return
        }
        setDonors(response.records)
        setTotal(response.total)
      })
      setIsInitialized(true)
    }
  }, [isInitialized])

  return (
    <Fade in={Boolean(donors)}>
      <Card>
        <CardHeader/>
        <CardContent>
          <Typography className={classes.description}>
            {"RenjuPortalの継続的な開発には皆様の支援が必要です。寄付のご協力を宜しくお願いします。"}
          </Typography>
          <Typography align="center">{"人数"}</Typography>
          <div className={classes.numberOfDonor}>
            <FavoriteIcon className={classes.icon}/>
            <Typography>{total}</Typography>
          </div>
          <div className={classes.donors}>
            {donors && donors.map((donor, index) => 
              <CustomAvatar
                alt={donor.displayName}
                name={donor.displayName}
                src={donor.avatarPhotoURL}
                className={classes.avatar}
                component={donor.userName ? Link : undefined}
                to={donor.userName ? makePath(`/user/${donor.userName}`, language) : undefined}
                key={index}
              />
            )}
          </div>
        </CardContent>
        <CardActions className={classes.cardActions}>
          <Button variant={'contained'} color='primary' component={Link} to={makePath('/donate', language)} fullWidth>
            {'寄付'}
          </Button>
        </CardActions>
      </Card>
    </Fade>
  )
}

export default withStyles(styles, { withTheme: true })(DonorListCard)



// WEBPACK FOOTER //
// ./src/Parts/DonorListCard/components/DonorListCard.js